var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "small-12 column" }, [
    _c("p", { staticClass: "text-small" }, [
      _vm._v(_vm._s(_vm._f("translate")("txtUploadFilesQUpload"))),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "file-list" },
      _vm._l(_vm.files, function (file) {
        return _c(
          "div",
          { staticClass: "small-12 column" },
          [
            _c("PrintFile", {
              attrs: {
                filename: file.name,
                filestatus: file.status,
                file: file.file,
              },
              on: { "delete-file": _vm.deleteFile },
            }),
          ],
          1
        )
      }),
      0
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "upload__input d-flex flex-column bg-shade-light pt-3 pb-3 px-2 p-4@medium flex-center text-center",
        on: {
          drop: function ($event) {
            $event.preventDefault()
            return _vm.dragndropFile.apply(null, arguments)
          },
          dragover: function ($event) {
            $event.preventDefault()
          },
        },
      },
      [
        _c(
          "svg",
          {
            staticClass: "svg-icon upload-icon m-auto svg-icon--xxlarge",
            attrs: {
              xmlns: "http://www.w3.org/2000/svg",
              viewBox: "0 0 50.73 33.62",
            },
          },
          [
            _c("path", {
              attrs: {
                d: "M40.71 14.63c-.37 0-.74.02-1.11.06l-1.24.13.09-1.24c.02-.3.03-.59.03-.87 0-7-5.69-12.7-12.7-12.7-3.21 0-6.28 1.2-8.63 3.38a12.68 12.68 0 00-4.03 8.28l-.09 1.1-1.09-.15c-.46-.06-.93-.09-1.4-.09C4.73 12.53 0 17.26 0 23.07c0 5.78 4.71 10.51 10.49 10.54H23.55V24.5v-.31c-.09.07-.14.11-.18.15-.68.67-1.36 1.34-2.02 2.03-.51.53-1.08.88-1.83.76-.71-.11-1.23-.51-1.48-1.18-.25-.65-.19-1.3.29-1.83.68-.75 1.42-1.46 2.14-2.19 1.18-1.19 2.37-2.37 3.55-3.56.8-.81 1.98-.81 2.67-.13.79.76 1.56 1.53 2.33 2.31l3.06 3.06c.31.3.62.6.77 1.02a1.9 1.9 0 01-.75 2.23c-.72.46-1.7.38-2.32-.23-.67-.65-1.32-1.32-1.98-1.98-.14-.15-.3-.28-.49-.47v9.42h13.45c5.5-.03 9.97-4.29 9.97-9.49 0-5.22-4.49-9.48-10.02-9.48z",
                fill: "#cad505",
              },
            }),
          ]
        ),
        _vm._v(" "),
        _c("label", { staticClass: "label-aligned text-small mt-2" }, [
          _vm._v(
            "\n            " +
              _vm._s(_vm._f("translate")("txtUploadArea")) +
              "\n        "
          ),
        ]),
      ]
    ),
    _vm._v(" "),
    _c("div", [
      _c("input", {
        ref: "uploadfiles",
        staticClass: "upload__file sr-only",
        attrs: {
          "aria-hidden": "true",
          type: "file",
          accept: _vm.allowedFileExtensions,
          name: "files",
          id: "fileuploadprintQ",
          "data-multiple-caption": "{count} files selected",
          multiple: "false",
        },
        on: { change: _vm.upload },
      }),
      _vm._v(" "),
      _c("input", { attrs: { type: "hidden", name: "ajax", value: "1" } }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "d-flex flex-column pt-3 flex-center text-center" },
        [
          _c("input", {
            staticClass: "btn btn--dark label-aligned m-auto w-auto@large",
            attrs: {
              type: "button",
              disabled: _vm.uploadInProgress,
              value: _vm._f("translate")("txtUploadPrintFile"),
            },
            on: { click: _vm.pickFile },
          }),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }